import { Menu, Moon, ShieldCheck, Sun, X } from "lucide-react";
import { useEffect, useState } from "react";

const navItems = [
  ["O livro", "#sobre-o-livro", "nav-about"],
  ["7 capítulos", "#capitulos", "nav-chapters"],
  ["Vídeo IA", "#video-apresentacao", "nav-video"],
  ["Relatos", "#depoimentos-ficcionais", "nav-stories"],
  ["Ferramentas", "#calculadora-habito", "nav-tools"],
  ["Dúvidas", "#perguntas-frequentes", "nav-faq"],
];

export function TopBar() {
  return (
    <div className="top-bar" data-testid="top-ethical-disclaimer-bar">
      <div className="top-bar-inner">
        <span><ShieldCheck size={14} aria-hidden="true" /> Apoio educativo e espiritual — sem promessa de cura</span>
        <a href="tel:188" data-testid="cvv-support-link">CVV 188 · apoio emocional gratuito</a>
      </div>
    </div>
  );
}

export function SiteHeader({ onPurchase, theme, onToggleTheme }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 18);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="header-inner">
        <a href="#topo" className="brand-mark" data-testid="brand-home-link" onClick={() => setMobileOpen(false)}>
          <span className="brand-number">30</span>
          <span><strong>DIAS</strong><small>PARA A LIBERDADE</small></span>
        </a>
        <button className="mobile-menu-toggle" type="button" onClick={() => setMobileOpen(!mobileOpen)} aria-expanded={mobileOpen} aria-label="Abrir menu" data-testid="mobile-menu-toggle">
          {mobileOpen ? <X size={21} /> : <Menu size={21} />}
        </button>
        <nav className={`main-nav ${mobileOpen ? "is-open" : ""}`} aria-label="Navegação principal">
          {navItems.map(([label, href, id]) => (
            <a href={href} key={id} data-testid={`${id}-link`} onClick={() => setMobileOpen(false)}>{label}</a>
          ))}
        </nav>
        <div className="header-actions">
          <button className="theme-toggle" type="button" onClick={onToggleTheme} aria-label="Alternar tema" data-testid="theme-toggle-button">
            {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <button className="button button-small" type="button" onClick={onPurchase} data-testid="nav-cta-purchase-button">Ler por R$ 29,99</button>
        </div>
      </div>
    </header>
  );
}

export function Marquee() {
  const items = ["LIBERDADE SEM APOSTAS", "FÉ QUE VIRA ROTINA", "DINHEIRO DE VOLTA PARA A VIDA", "PAZ QUE GUARDA O CORAÇÃO", "30 PÁGINAS DE AÇÃO"];
  return (
    <section className="marquee-window" aria-label="Princípios do livro" data-testid="editorial-marquee-ribbon">
      <div className="marquee-track">
        {[...items, ...items].map((item, index) => <span key={`${item}-${index}`}>{item}<i>✦</i></span>)}
      </div>
    </section>
  );
}
